import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const userRoleSelectStyles = makeStyles((theme: Theme) =>
    createStyles({
        selectField: {
            width: "100%",
            "& .MuiTypography-root": {
                color: theme.palette.text.primary,
            },
            "&.Mui-disabled": {
                border: `1px solid ${theme.palette.text.disabled}`,
                "&:hover": {
                    border: `1px solid ${theme.palette.text.disabled}`,
                },
                "& .MuiTypography-root": {
                    color: theme.palette.text.disabled,
                },
            },
            "& .MuiSelect-select": {
                paddingTop: 20,
                paddingBottom: 20,
            },
            "& .MuiSelect-icon": {
                fontSize: 16,
                right: theme.spacing(2),
            },
        },
        filterByRolePaper: {
            borderRadius: theme.spacing(4),
            border: `1px solid ${theme.palette.secondary.light}`,
            boxShadow: "0px 1px 3px 0px #0000001A 0px 1px 2px 0px #0000000F",
        },
        roleSelectMenuItem: {
            "& .MuiListItemText-primary": {
                fontSize: 16,
                fontWeight: 600,
                color: theme.palette.text.primary,
            },
            "& .MuiListItemText-secondary": {
                fontSize: 14,
                fontWeight: 500,
                color: theme.palette.text.disabled,
            },
        },
    })
);

export default userRoleSelectStyles;
